var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20929_60432)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.084 15.75V14.25C13.084 13.4544 12.7679 12.6913 12.2053 12.1287C11.6427 11.5661 10.8796 11.25 10.084 11.25H4.08398C3.28833 11.25 2.52527 11.5661 1.96266 12.1287C1.40005 12.6913 1.08398 13.4544 1.08398 14.25V15.75",
    stroke: "#323739",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.08398 8.25C8.74084 8.25 10.084 6.90685 10.084 5.25C10.084 3.59315 8.74084 2.25 7.08398 2.25C5.42713 2.25 4.08398 3.59315 4.08398 5.25C4.08398 6.90685 5.42713 8.25 7.08398 8.25Z",
    stroke: "#323739",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.584 15.7502V14.2502C17.5835 13.5855 17.3623 12.9397 16.955 12.4144C16.5478 11.889 15.9776 11.5138 15.334 11.3477",
    stroke: "#323739",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.334 2.34766C12.9793 2.51288 13.5513 2.88818 13.9597 3.41439C14.3682 3.9406 14.5899 4.58778 14.5899 5.25391C14.5899 5.92003 14.3682 6.56722 13.9597 7.09342C13.5513 7.61963 12.9793 7.99493 12.334 8.16016",
    stroke: "#323739",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20929_60432"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.333984)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.eab2c55ccc315b3fa71b73854cfb3181.svg";
export { ForwardRef as ReactComponent };